import { Form, Formik } from 'formik'
import { useLucaSignUp } from '../hooks/useLucaSignUp'
import { FieldWithErrorMessage } from '../../../ui/FieldWithErrorMsg'
import * as Yup from 'yup'
import { useSwiper } from 'swiper/react'

/**
 *
 * @returns {JSX.Element} The rendered component.
 */

const validationSchema = Yup.object({
  companyName: Yup.string().required('Ingresa el nombre de tu organización'),
  userType: Yup.string().required('Selecciona un tipo de usuario')
})

export function StepForm2() {
  const addAccountProfileValues = useLucaSignUp(state => state.setAccountProfile)
  const accountProfile = useLucaSignUp(state => state.accountProfile)
  const swiper = useSwiper()

  const initialValues = {
    companyName: accountProfile?.companyName ?? '',
    userType: accountProfile?.userType ?? ''
  }

  const handleNext = (values, actions) => {
    addAccountProfileValues(values)
    swiper.slideNext()
    actions.setSubmitting(false)
  }

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={handleNext}
      enableReinitialize
    >
      {({ setFieldValue, values, errors, touched }) => (
        <Form className='step-two-form w-full max-w-lg mx-auto flex flex-col gap-6 text-white lg:text-gray-800'>
  {/* 🔹 INPUT */}
  <div>
    <div className="flex items-start gap-2 mb-3">
      <label className="block text-sm text-white/80 lg:text-gray-600">
        ¿Cómo se llamará tu organización o grupo?
      </label>

      {/* Tooltip */}
      <div className="relative group cursor-pointer select-none">
        <span className="text-xs bg-gray-300 text-gray-800 rounded-full w-4 h-4 flex items-center justify-center">
          i
        </span>

        {/* Tooltip text */}
        <div
          className="
            absolute left-1/2 -translate-x-1/2 top-6
            w-48
            opacity-0 group-hover:opacity-100
            bg-primary text-white text-xs px-3 py-2 rounded-lg shadow-lg
            transition-opacity duration-200
            z-20
            pointer-events-none group-hover:pointer-events-auto
          "
        >
          <p className="font-medium text-white mb-1">¿Qué es una organización?</p>
          <p className="text-white/90">
            Es un espacio donde agrupas una o más empresas. Puedes empezar con una y sumar otras en el tiempo.
          </p>
        </div>
      </div>
    </div>
    <FieldWithErrorMessage
      name='companyName'
      placeholder='Ej: Grupo Pérez / Holding Norte / Mis Empresas'
      className='w-full px-5 py-4 rounded-xl 
        bg-white/10 lg:bg-gray-100 
        border border-white/10 lg:border-transparent 
        focus:border-primary focus:bg-white 
        outline-none text-sm 
        text-white lg:text-gray-800 
        placeholder:text-white/50 lg:placeholder:text-gray-400'
    />
  </div>

  {/* 🔹 SELECT CARDS */}
  <div>
    <label className='block text-sm text-white/80 lg:text-gray-600 mb-3'>
      ¿Cómo usarás TryLuca?
    </label>

    <div className='step-two-grid grid grid-cols-1 sm:grid-cols-2 gap-4'>
      <button
        type='button'
        onClick={() => setFieldValue('userType', 'contador')}
        className={`p-6 rounded-xl border transition 
          h-32 w-full flex flex-col justify-start
          ${
            values.userType === 'contador'
              ? 'border-accent2 bg-accent2/10'
              : 'border-white/30 lg:border-gray-200 hover:border-primary/40'
          }`}
      >
        <div className='font-semibold text-base text-center text-white lg:text-gray-800'>
          Contador
        </div>
        <div className='w-full h-px bg-white/20 lg:bg-gray-300 my-2' />
        <div className='text-xs text-white/60 lg:text-gray-500 text-center leading-snug'>
          Gestionas varias empresas y necesitas reportes rápidos.
        </div>
      </button>

      <button
        type='button'
        onClick={() => setFieldValue('userType', 'empresa')}
        className={`p-6 rounded-xl border transition 
          h-32 w-full flex flex-col justify-start
          ${
            values.userType === 'empresa'
              ? 'border-accent2 bg-accent2/10'
              : 'border-white/30 lg:border-gray-200 hover:border-primary/40'
          }`}
      >
        <div className='font-semibold text-base text-center text-white lg:text-gray-800'>
          Socio / Empresa
        </div>
        <div className='w-full h-px bg-white/20 lg:bg-gray-300 my-2' />
        <div className='text-xs text-white/60 lg:text-gray-500 text-center leading-snug'>
          Quieres claridad financiera y control en tiempo real.
        </div>
      </button>
    </div>
  </div>

  {/* 🔹 BOTÓN */}
  <button
    type='submit'
    className='w-full py-4 rounded-xl bg-primary text-white font-semibold text-sm shadow-md'
  >
    👉 Siguiente paso
  </button>
</Form>
      )}
    </Formik>
  )
}
